export default __webpack_public_path__ + "static/FoodBeverage-3356aad0bf9499d7285836fdf89363e2.png";